var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._l(_vm.general_fields, function (field) {
      return _c(
        "div",
        { key: field.path + ":" + field.key, staticClass: "form-group mt-3" },
        [
          field.type === "object"
            ? [
                _c(
                  "div",
                  { staticClass: "border rounded p-3" },
                  [
                    _c("div", { staticClass: "font-weight-bold mb-3" }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.__t(field.title)) +
                          "\n                "
                      ),
                    ]),
                    _vm._v(" "),
                    _vm._l(field.children, function (subKey) {
                      return _c(
                        "div",
                        {
                          key: field.key + ":" + subKey,
                          staticClass: "form-group mt-3",
                        },
                        [
                          _vm.isTranslatedObject(
                            _vm.getNestedFieldValue(field, subKey)
                          )
                            ? [
                                _c(
                                  "div",
                                  { staticClass: "font-weight-bold mb-2" },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(_vm.__t(subKey.toUpperCase())) +
                                        "\n                        "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _vm._l(
                                  _vm.translationVisibleLanguages,
                                  function (lang) {
                                    return _c(
                                      "div",
                                      {
                                        key:
                                          field.key + ":" + subKey + ":" + lang,
                                        staticClass: "form-group mt-2",
                                      },
                                      [
                                        _c(
                                          "label",
                                          { staticClass: "form-label" },
                                          [
                                            _vm._v(
                                              "\n                                " +
                                                _vm._s(
                                                  _vm.__t(subKey.toUpperCase())
                                                ) +
                                                " (" +
                                                _vm._s(lang.toUpperCase()) +
                                                ")\n                            "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("input", {
                                          staticClass: "form-control",
                                          attrs: { type: "text" },
                                          domProps: {
                                            value:
                                              _vm.getTranslatedNestedFieldValue(
                                                field,
                                                subKey,
                                                lang
                                              ),
                                          },
                                          on: {
                                            input: function ($event) {
                                              return _vm.setTranslatedNestedFieldValue(
                                                field,
                                                subKey,
                                                lang,
                                                $event.target.value
                                              )
                                            },
                                          },
                                        }),
                                      ]
                                    )
                                  }
                                ),
                              ]
                            : [
                                _c("label", { staticClass: "form-label" }, [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(_vm.__t(subKey.toUpperCase())) +
                                      "\n                        "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("input", {
                                  staticClass: "form-control",
                                  attrs: { type: "text" },
                                  domProps: {
                                    value: _vm.getNestedFieldValue(
                                      field,
                                      subKey
                                    ),
                                  },
                                  on: {
                                    input: function ($event) {
                                      return _vm.setNestedFieldValue(
                                        field,
                                        subKey,
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ],
                        ],
                        2
                      )
                    }),
                  ],
                  2
                ),
              ]
            : field.key === "city_id"
            ? [
                _c("label", { staticClass: "form-label" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.__t(field.title)) +
                      "\n            "
                  ),
                ]),
                _vm._v(" "),
                _c("v-select", {
                  attrs: {
                    value: _vm.selectedCity,
                    label: "name",
                    options: _vm.cities,
                    filterable: false,
                    clearable: true,
                  },
                  on: { input: _vm.onCityChange },
                }),
              ]
            : field.key === "category_code"
            ? [
                _c("label", { staticClass: "form-label" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.__t(field.title)) +
                      "\n            "
                  ),
                ]),
                _vm._v(" "),
                _c("v-select", {
                  attrs: {
                    value: _vm.selectedCategory,
                    label: "code",
                    options: _vm.categories,
                    filterable: false,
                    clearable: true,
                  },
                  on: { input: _vm.onCategoryChange },
                }),
              ]
            : field.type === "translated"
            ? [
                _c(
                  "div",
                  { staticClass: "border rounded p-3" },
                  [
                    _c("div", { staticClass: "font-weight-bold mb-3" }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.__t(field.title)) +
                          "\n                "
                      ),
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.translationVisibleLanguages, function (lang) {
                      return _c(
                        "div",
                        {
                          key: field.key + ":" + lang,
                          staticClass: "form-group mt-2",
                        },
                        [
                          _c("label", { staticClass: "form-label" }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.__t(field.title)) +
                                " (" +
                                _vm._s(lang.toUpperCase()) +
                                ")\n                    "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            staticClass: "form-control",
                            attrs: { type: "text" },
                            domProps: {
                              value: _vm.getTranslatedFieldValue(field, lang),
                            },
                            on: {
                              input: function ($event) {
                                return _vm.setTranslatedFieldValue(
                                  field,
                                  lang,
                                  $event.target.value
                                )
                              },
                            },
                          }),
                        ]
                      )
                    }),
                  ],
                  2
                ),
              ]
            : [
                _c("label", { staticClass: "form-label" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.__t(field.title)) +
                      "\n            "
                  ),
                ]),
                _vm._v(" "),
                _c("input", {
                  staticClass: "form-control",
                  attrs: { type: "text" },
                  domProps: { value: _vm.getFieldValue(field) },
                  on: {
                    input: function ($event) {
                      return _vm.setFieldValue(field, $event.target.value)
                    },
                  },
                }),
              ],
        ],
        2
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }